import React from 'react'
import { Field } from 'redux-form'
import { defaultValidators } from '../../../lib/validation'
import {
  Input,
  Error,
  Select,
  FormControlWrapper,
  Button
} from '../../uiLib'

const ProfileForm = props => (
  <form onSubmit={props.handleSubmit(props._handleSubmit)} noValidate>
    <React.Fragment>
      <h2 className="title is-6">{props.t('general')}</h2>
      <FormControlWrapper
        horizontal
        label={props.t('common:username')}
      >
        <label id="username" className="label is-normal has-text-white">{props.username}</label>
      </FormControlWrapper>
      <Input
        id="first_name"
        name="user.first_name"
        label={props.t('common:firstname')}
        required
        horizontal
        formComponent
        placeholder={props.t('common:firstname')}
        validate={[defaultValidators.required]}
      />
      <Input
        id="last_name"
        name="user.last_name"
        label={props.t('common:lastname')}
        required
        horizontal
        formComponent
        placeholder={props.t('common:lastname')}
        validate={[defaultValidators.required]}
      />
      <Input
        id="phone"
        name="user.phone"
        label={props.t('common:phone')}
        required
        horizontal
        formComponent
        placeholder={props.t('common:phone')}
        validate={[defaultValidators.required, defaultValidators.phone]}
      />
      <h2 className="title is-6 m-t-lg">{props.t('billing_address')}</h2>
      <Input
        id="business_name"
        name="address.business_name"
        label={props.t('common:business-name')}
        required
        horizontal
        help={props.t('common:optional-field')}
        formComponent
        placeholder={props.t('common:business-name')}
      />
      <Input
        id="address1"
        name="address.address1"
        label={props.t('common:address1')}
        required
        horizontal
        formComponent
        placeholder={props.t('common:address1')}
        validate={[defaultValidators.required]}
      />
      <Input
        id="address2"
        name="address.address2"
        label={props.t('common:address2')}
        required
        horizontal
        formComponent
        help={props.t('common:optional-field')}
        placeholder={props.t('common:address2')}
      />
      <Input
        id="city"
        name="address.city"
        label={props.t('common:city')}
        required
        horizontal
        formComponent
        placeholder={props.t('common:city')}
        validate={[defaultValidators.required]}
      />
      <Select
        id="country"
        name="address.country"
        label={props.t('common:country')}
        required
        formComponent
        horizontal
        placeholder={props.t('common:please-select')}
        validate={[defaultValidators.required]}
        values={props.countries}
      />
      <Select
        id="state"
        name="address.state"
        label={props.t('common:state-or-province')}
        required
        formComponent
        horizontal
        placeholder={props.t('common:please-select')}
        validate={[defaultValidators.required]}
        disabled={!props.regions.length}
        values={props.regions}
      />
      <Input
        id="zip"
        name="address.zip"
        label={props.t('common:postal')}
        required
        horizontal
        formComponent
        placeholder={props.t('common:postal')}
        validate={[
          defaultValidators.required,
          defaultValidators.zip
        ]}
      />
      <FormControlWrapper
        horizontal
        labelOffset
      >
        <label className="checkbox">
          <Field
            name="user.opt_in_email"
            id="opt_in_email"
            component="input"
            type="checkbox"
            normalize={v => !!v}
          />
          &nbsp;{props.t('common:opt-in-email')}
        </label>
      </FormControlWrapper>
      { props.error &&
        <Error message={props.t(props.error)} />
      }
      <FormControlWrapper
        horizontal
        labelOffset
      >
        <Button
          disabled={props.submitting}
          loading={props.loading}
          Button="m-b-sm m-t-md"
          outlined
          btType="primary"
        >
          {props.t('common:submit')}
        </Button>
      </FormControlWrapper>
    </React.Fragment>
  </form>
)

export default ProfileForm



// WEBPACK FOOTER //
// ./components/Common/UserDetails/Profile.js